import { WebApiError } from "@faire/web-api--source/WebApiError";
export var shouldRetryEndpoint = function(failureCount, error) {
    var hasNotExceededFailCount = failureCount < 3;
    if (!error || !(error instanceof WebApiError)) {
        return hasNotExceededFailCount;
    }
    var _error_httpStatusCode;
    var httpStatusCode = (_error_httpStatusCode = error === null || error === void 0 ? void 0 : error.httpStatusCode) !== null && _error_httpStatusCode !== void 0 ? _error_httpStatusCode : 0;
    return hasNotExceededFailCount && (httpStatusCode < 400 || httpStatusCode >= 500);
};
